import { useAppSelector } from '../store';

export function useAccessToken(): string {
    const accessToken = useAppSelector((state) => state.userData.accessToken);
    if (accessToken === null) {
        throw Error('Invalid access token state');
    }
    return accessToken;
}
